export enum CatalogItemType {
  Vacancy = 2,
  Resume = 1,
}
